import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import api2 from "../../../Component/axios_Interceptor/api2";
import url from "../../../Component/server";
import { fontStyles } from "../../../Component/style/common_font";
import { Icon } from "../../../Component/style/common_style";

const AdminLogin = () => {
  const Navigate = useNavigate();
  const ismobile = /Android|webOS|iPhone|iPad|iPod/i.test(navigator.userAgent);

  useEffect(() => {
    if (localStorage.getItem("authority")) {
      if (ismobile) {
        Navigate("/admin/livelist");
      } else {
        Navigate("/admin/dashboard");
      }
    }
  }, []);

  const [id, setID] = useState("");
  const [pw, setPW] = useState("");
  const setting_id = (e: React.ChangeEvent<HTMLInputElement>) =>
    setID(e.target.value.replace(" ", ""));
  const setting_pw = (e: React.ChangeEvent<HTMLInputElement>) =>
    setPW(e.target.value);

  const adminLogin = async () => {
    if (id.trim() === "" || pw === "") {
      alert("아이디/비밀번호를 입력해주세요.");
      return;
    }
    try {
      const res = await api2.post(url.Communication_url.seller_login, {
        userid: id,
        userpw: pw,
      });
      const userinfo = res.data;
      if (userinfo.accessToken) {
        const token_refresh = userinfo.refreshToken;
        localStorage.setItem("key", token_refresh);
        localStorage.setItem("authority", "ok");
        if (ismobile) {
          Navigate("/admin/livelist");
        } else {
          Navigate("/admin/dashboard");
        }
      }
    } catch (error) {
      alert("아이디/비밀번호를 다시 확인해주세요.");
      console.error("실패:", error, id, pw);
    }
    Navigate("/admin/dashboard");
  };

  const keyPress_keyword = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      adminLogin();
    }
  };

  return (
    <Container>
      <Box>
        <div className="logo">
          <Icon
            style={{ height: 44 }}
            src={require("../../../Image/Logo_Text.png")}
          />
        </div>

        <label>아이디</label>
        <InputBox
          value={id}
          onChange={setting_id}
          placeholder="아이디를 입력해주세요."
        />

        <label>비밀번호</label>
        <InputBox
          value={pw}
          type={"password"}
          onChange={setting_pw}
          placeholder="비밀번호를 입력해주세요."
          onKeyDown={keyPress_keyword}
        />

        <Btn onClick={adminLogin}>로그인</Btn>
      </Box>
    </Container>
  );
};

export default AdminLogin;

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  padding: 0rem 1rem;
  width: 100%;
  height: 100vh;
  background-color: #f8f8f8;
  overflow: hidden;
`;
const Box = styled.div`
  width: 100%;
  max-width: 20rem;
  padding: 2rem;
  margin: auto;
  background-color: white;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  label {
    display: block;
    margin-top: 1.3rem;
    margin-bottom: 5px;
    ${fontStyles.medium}
  }
  div.logo {
    position: relative;
    height: 44px;
  }
  img {
    position: absolute;
    left: -3%;
  }
`;
const InputBox = styled.input`
  box-sizing: border-box;
  width: 100%;
  padding: 0.8rem 1rem;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  outline: 0;
  &:hover,
  &:focus {
    border: 1px solid #454545;
  }
`;
const Btn = styled.div`
  padding: 0.8rem;
  margin-top: 1rem;
  ${fontStyles.medium}
  text-align: center;
  color: white;
  border-radius: 8px;
  background: linear-gradient(135deg, #7955f0, #3209b9);
  cursor: pointer;
`;
